import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'icon-selection-dialog',
    templateUrl: './icon-selection-dialog.component.html',
    styleUrls: ['./icon-selection-dialog.component.scss'],
    standalone: false
})
export class IconSelectionDialogComponent implements OnInit {

  type;
  iconList;
  initialIconList;
  public iconType = 'normal';
  public searchValue = '';

  constructor(
    public dialogRef: MatDialogRef<IconSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    this.type = this.data.type;
    this.iconList = this.data.icons;
    this.initialIconList = this.data.icons;
    this.updateList();
  }

  onSelect(event) {
    this.dialogRef.close(event);
  }

  abort() {
    this.dialogRef.close();
  }

  onSearchChange() {
    this.updateList();
  }

  changeType(type) {
    this.iconType = type;
    this.updateList();
  }

  updateList() {
    if (this.type === 'old') {
      return;
    }
    if (this.iconType === 'normal') {
      this.iconList = this.initialIconList.filter(el => el.indexOf('-blank') === -1 && el.indexOf('-contrast') === -1);
    } else if (this.iconType === 'contrast') {
      this.iconList = this.initialIconList.filter(el => el.indexOf('-contrast') !== -1);
    } else if (this.iconType === 'blank') {
      this.iconList = this.initialIconList.filter(el => el.indexOf('-blank') !== -1);
    }
    if (this.searchValue) {
      this.iconList = this.iconList.filter(el => el.indexOf(this.searchValue) !== -1);
    }
  }

}
